import React from 'react';
import { AppService } from '@aperza/util';
import { Message } from '@aperza/ui';
import TdLink from '../common/TdLink';
export default class LoginLink extends React.Component {
    render() {
        let appConfig = AppService.appConfig();
        let domain = appConfig.baseComDomain;
        let protocol = 'https';
        let port = '';
        if (domain.includes('.local.')) {
            protocol = 'http';
            port = ':8000';
        }
        let loginUrl = `${protocol}://id${appConfig.baseComDomain}${port}/login/${appConfig.serviceType}/?rp=header&path=${AppService.encodedPath()}`;
        return (React.createElement(TdLink, { action: "usermenu_login", href: loginUrl },
            React.createElement("div", { className: "login" },
                React.createElement(Message, { messageId: "userMenu.login" }))));
    }
}
